import { getFilmmakersSSOLink } from "api-generate-types/src/api/filmmakers";

export const fixUrl = (url: string) => {
  if (!url.match(/^https?:\/\//i) && url) {
    url = "https://" + url;
  }

  return url;
};

export const handleWebsite = (website?: string) => {
  if (!website) {
    return;
  }

  window.open(fixUrl(website), "_blank");
};

export const handleFilmmakers = (profileIdAttr: string) => {
  window.open(
    `https://www.filmmakers.eu/spotlight-redirect/${profileIdAttr}`,
    "_blank"
  );
};

export const handleRedirectToFilmmakers = async () => {
  const data = await getFilmmakersSSOLink(
    "https://www.filmmakers.eu/sso/spotlight/inbound"
  );
  window.open(data.url, "_blank");
};
